import { checkIsActiveGoogleMap } from '../utils';

import { googleMapApi } from './googleMapApi';
import { hereMapApi } from './hereMapApi';
import { locatorServiceAPI } from 'shared/services';

import {
  GeocodeProps,
  PlannedRoutesFilter,
  PlannedRoutes,
  PlannedRouteStations,
  PlannedRoutesPrices,
  PlannedRoutesPricesFilter,
  PlannedRouteStationsFilter
} from '../types';

export const mapApi = {
  getPredictedPlaces: (search: string) => {
    if (checkIsActiveGoogleMap()) {
      return googleMapApi.getPredictedPlaces(search);
    } else {
      return hereMapApi.getPredictedPlaces(search);
    }
  },
  geocode: (props: GeocodeProps) => {
    if (checkIsActiveGoogleMap()) {
      return googleMapApi.geocode(props)
    } else {
      return hereMapApi.geocode(props);
    }
  },
  getPlannedRoutes: (filter: PlannedRoutesFilter) => locatorServiceAPI.post<PlannedRoutes>('route-planning-sessions', filter),
  getPlannerRoutesStations: (planId: PlannedRoutes['planId'], filter: PlannedRouteStationsFilter) => locatorServiceAPI.post<{ routeStations: PlannedRouteStations[]; }>(`route-planning-sessions/${planId}/stations`, { stationCriteria: filter }),
  getPlannedRoutesPrices: (planId: PlannedRoutes['planId'], filter: PlannedRoutesPricesFilter) => locatorServiceAPI.post<PlannedRoutesPrices>(`route-planning-sessions/${planId}/prices`, { priceCriteria: filter, includeRouteTags: true }),
  sortingRoutePoints: (routePolyline: string, via: PlannedRoutesFilter['via']) => locatorServiceAPI.post<{ via: PlannedRoutesFilter['via']; }>( 'routes/order-waypoints', { routePolyline, via }),
};
